var map = {
	"./act": 1533,
	"./act.tsx": 1533,
	"./gmat": 1534,
	"./gmat.tsx": 1534,
	"./gre": 1535,
	"./gre.tsx": 1535,
	"./ielts": 1536,
	"./ielts.tsx": 1536,
	"./ielts_general_training": 1537,
	"./ielts_general_training.tsx": 1537,
	"./lsat": 1538,
	"./lsat.tsx": 1538,
	"./mcat": 1539,
	"./mcat.tsx": 1539,
	"./sat": 1540,
	"./sat.tsx": 1540,
	"./toefl": 1541,
	"./toefl.tsx": 1541
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2520;
module.exports = webpackAsyncContext;